<app-modal [title]="data.readOnly ? 'Ubicación en el mapa' : 'Seleccionar ubicación'">
  <app-location-picker
    [latitud]="selectedCoordinates?.latitud"
    [longitud]="selectedCoordinates?.longitud"
    [disabled]="data.readOnly"
    (coordinatesChange)="onCoordinatesChange($event)"
  />

  @if (data.readOnly) {
    <div class="mt-6 flex justify-end">
      <app-button size="sm" variant="outline" startIcon="close" (btnClick)="close()">
        Cerrar
      </app-button>
    </div>
  } @else {
    <app-creation-buttons
      [valid]="selectedCoordinates !== null"
      (onCreateClick)="confirm()"
      (onCancelClick)="close()"
    />
  }
</app-modal>
